import React, { useContext, useEffect, useState } from "react";
import Title from "../../components/Title";
import {
  Checkbox,
  Dropdown,
  IDropdownOption,
  IDropdownStyles,
  Label,
  Spinner,
  SpinnerSize,
  Stack,
} from "@fluentui/react";
import { gql, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import AppContext from "../../AppContext";
import "./style.scss";
import { normalizeBoolJSX } from "../../utils/functions";
import moment from "moment";
export interface IItem {
  Error?: String;
  Semana: number;
  Anyo: number;
  Visible: boolean;
  Ventas: string;
  Eventos: boolean;
}

const dropdownStyles: Partial<IDropdownStyles> = {
  root: {
    width: 80,
    transform: "translateY(4px)",
    marginBottom: 8,
    marginLeft: 14,
    zIndex: 1,
    display: "flex",
    gap: 1,
  },
  label: {
    color: "var(--primary-color)",
    fontWeight: 400,
    padding: "7px 0px",
    fontSize: "13px",
    margin: "0px 6px 0px 0px",
  },
  title: {
    borderColor: "transparent",
    transition: "background 0.3s",
  },
  dropdown: {
    selectors: {
      "&:hover .ms-Dropdown-title, &:active .ms-Dropdown-title": {
        borderColor: "transparent",
        background: "#f3f2f1",
      },
      ":focus::after": {
        border: "1px solid transparent",
      },
    },
  },
  callout: {
    minWidth: 130,
  },
};

const CuadroVisibilidad = () => {
  
  const { semanasDatos } = useContext(AppContext);
  const currentYear = moment().year();
  
  const [selectedYear, setSelectedYear] = useState<IDropdownOption | null>({
    key: currentYear,
    text: `${currentYear}`,
  });
  const [items, setItems] = useState<any[] | undefined>();
  const [openWeek, setOpenWeek] = useState<number | null>(null);
  const [loadingWeek, setLoadingWeek] = useState<number | null>(null);
  const [faltantesMap, setFaltantesMap] = useState<Record<number, string[]>>({});
  //const [loading, setLoading] = useState(false)

  const [setRow] = useMutation(gql`
    mutation ($year: Int!, $week: Int!, $visible: Boolean) {
      setWeekVisibility(
        input: { Year: $year, Week: $week, Visible: $visible }
      ) {
        Completed
        Error
      }
    }
  `);

  const MISSING_QUERY = gql`
    query ($year: Int!, $semana: Int!) {
      getMissingCadenas(Anyo: $year, Semana: $semana)
    }
  `;

  const pendingWeekRef = React.useRef<number | null>(null);

  const [fetchMissing] = useLazyQuery(MISSING_QUERY, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      const wk = pendingWeekRef.current;
      if (wk !== null) {
        setFaltantesMap((prev) => ({ ...prev, [wk]: data.getMissingCadenas ?? [] }));
        setOpenWeek(wk);
        setLoadingWeek(null);
        pendingWeekRef.current = null;
      }
    },
  });

  const handleVerFaltantes = (item: IItem) => {
    const semana = item.Semana;
    if (openWeek === semana) { setOpenWeek(null); return; }
    if (faltantesMap[semana] !== undefined) { setOpenWeek(semana); return; }
    pendingWeekRef.current = semana;
    setLoadingWeek(semana);
    fetchMissing({ variables: { year: item.Anyo, semana: item.Semana + 1 } });
  };

  const WEEK_QUERY = gql`
    query ($year: Int!) {
      getWeekVisibility(Anyo: $year)
    }
  `;

  let qry = useQuery(WEEK_QUERY, {
    variables: {
      year: selectedYear?.key,
    },
  });
  console.log(qry.data?.getWeekVisibility);
  console.log(qry.data?.getWeekVisibility.map((registro: IItem) => registro.Ventas));

  useEffect(() => {
    if (qry.data?.getWeekVisibility === undefined) return;
    let newData: any = qry.data?.getWeekVisibility?.filter(
      (i: IItem) => i.Semana !== 1
    );
    let newData2 = newData.map((i: IItem) => {
      return {
        ...i,
        Semana: i.Semana - 1,
      };
    });
    newData2.sort((a: IItem, b: IItem) => a.Semana - b.Semana);
    setItems(newData2);
  }, [qry.data]);

  function _onChange(
    ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
    isChecked?: boolean
  ) {
    if (!(ev?.target instanceof HTMLInputElement)) return;
    const week = parseInt(`${ev?.target.dataset?.week}`);
    const year = parseInt(`${ev?.target.dataset?.year}`);
    // Actualización optimista para que el checkbox responda visualmente de inmediato
    setItems((prev) =>
      prev?.map((i) =>
        i.Semana === week && i.Anyo === year ? { ...i, Visible: isChecked } : i
      )
    );
    setRow({
      variables: { year, week: week + 1, visible: isChecked },
    }).then(() => {
      qry.refetch();
    });
  }

  const onRenderCell = (
    item?: IItem,
    index?: number | undefined
  ): JSX.Element => {
    let vals: number[] = item?.Ventas.split("/").map((x) => +x) || [0, 0];
    let cellClass = "",
      tooltip = "";
    //if(vals[0] === vals[1]) cellClass = "completed"
    if (vals[0] === vals[1]) {
    cellClass = "completed";
    tooltip = "Datos de ventas completos";
  } else if (vals[0] > vals[1]) {
    cellClass = "overflow";
    tooltip = "Hay datos de más";
  } else if (vals[0] < vals[1]) {
    cellClass = "incomplete";
    tooltip = "Datos de ventas incompletos";
  } else if (vals[0] * 2 < vals[1]) {
    cellClass = "empty";
    tooltip = "Datos de ventas casi vacíos";
  }

    const hasFaltantes = vals[0] < vals[1];
    const isOpen = openWeek === item?.Semana;
    const isLoading = loadingWeek === item?.Semana;

    return !item ? (
      <></>
    ) : (
      <div key={index} className="row-wrapper">
        <div className="row">
          <div
            className="cell value small"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Checkbox
              className={"visibilityCheckbox"}
              checked={item.Visible}
              onChange={_onChange}
              inputProps={{
                ...({
                  "data-week": `${item.Semana}`,
                  "data-year": `${item.Anyo}`,
                } as any),
              }}
            />
          </div>
          <div className="cell value">
            {item.Semana < 10 ? `0${item.Semana}` : `${item.Semana}`}/{item.Anyo}
          </div>
          <div className={`cell value ${cellClass}`}>
            {cellClass === "" ? (
              <>{item.Ventas}</>
            ) : (
              <abbr title={tooltip}>{item.Ventas}</abbr>
            )}
          </div>
          <div className="cell value">{normalizeBoolJSX(item.Eventos)}</div>
          <div className="cell value faltantes-cell">
            {hasFaltantes && (
              <button
                className={`faltantes-btn${isOpen ? " open" : ""}`}
                onClick={(e) => { e.stopPropagation(); handleVerFaltantes(item); }}
                disabled={isLoading}
              >
                {isLoading ? "..." : isOpen ? "Ocultar" : "Ver pendientes"}
              </button>
            )}
          </div>
        </div>
        {isOpen && (
          <div className="faltantes-list">
            {(faltantesMap[item.Semana] ?? []).length > 0 ? (
              <>
                <button
                  className="faltantes-copy-btn"
                  onClick={() => navigator.clipboard.writeText((faltantesMap[item.Semana] ?? []).join("\n"))}
                >
                  Copiar
                </button>
                {(faltantesMap[item.Semana] ?? []).map((c) => (
                  <div key={c} className="faltante-item">{c}</div>
                ))}
              </>
            ) : (
              <div className="faltante-item">Sin cadenas faltantes</div>
            )}
          </div>
        )}
      </div>
    );
  };

  let yearOpts: IDropdownOption[] = [];
  /*
  useEffect(() => {
    for (
      let year = semanasDatos[0].year;
      year <= semanasDatos[1].year;
      year++
    ) {
      yearOpts.push({ key: year, text: `${year}` });
    }
  });
	*/

  yearOpts = [
    { key: 2019, text: "2019" },
    { key: 2020, text: "2020" },
    { key: 2021, text: "2021" },
    { key: 2022, text: "2022" },
    { key: 2023, text: "2023" },
    { key: 2024, text: "2024" },
    { key: 2025, text: "2025" },
    { key: 2026, text: "2026" },
    
  ];

  const changeYear = (_: any, item: any) => {
    setSelectedYear(item);
  };

  const itemsCount: number = items ? items?.length : 0;
  const itemsActive: number = items
    ? items.filter((i) => !!i.Visible).length
    : 0;

  return (
    <>
      <Title title={"Cuadro de visibilidad"} />

      <div className={`table-container small`}>
        <div className="table">
          <Stack horizontal>
            <Dropdown
              label="Año"
              placeholder={selectedYear ? selectedYear.text : ""}
              options={yearOpts}
              styles={dropdownStyles}
              onChange={changeYear}
            />
            <Label
              style={{
                margin: "auto 12px auto auto",
                fontSize: 12,
                fontWeight: 400,
              }}
            >
              {itemsCount === 0
                ? ""
                : `${itemsActive}/${itemsCount} semanas visibles`}
            </Label>
          </Stack>
          {qry?.loading && (
            <Spinner
              style={{ paddingBottom: "20px" }}
              size={SpinnerSize.large}
            />
          )}
          {!qry?.loading && (
            <>
              <div className="row header">
                <div className="cell headercell small"></div>
                <div className="cell headercell">Semana</div>
                <div className="cell headercell">Ventas</div>
                <div className="cell headercell">Eventos</div>
                <div className="cell headercell faltantes-cell"></div>
              </div>

              <div>{items?.map((item, index) => onRenderCell(item, index))}</div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default CuadroVisibilidad;
